var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramGradient = function SvgInstagramGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-gradient_svg__a)",
    d: "M19.973 38h-.084C9.44 38 .937 29.495.937 19.042v-.084C.937 8.505 9.439 0 19.889 0h.084c10.45 0 18.952 8.505 18.952 18.958v.084C38.925 29.495 30.423 38 19.973 38m-.084-36.714c-9.742 0-17.667 7.927-17.667 17.672v.084c0 9.744 7.925 17.672 17.667 17.672h.084c9.742 0 17.667-7.927 17.667-17.672v-.084c0-9.745-7.925-17.672-17.667-17.672z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-gradient_svg__b)",
    d: "M24.38 9.92h-8.87a4.45 4.45 0 0 0-4.444 4.445v8.117a4.45 4.45 0 0 0 4.444 4.445h8.87a4.45 4.45 0 0 0 4.444-4.445v-8.117A4.45 4.45 0 0 0 24.38 9.92m-11.746 4.445a2.88 2.88 0 0 1 2.876-2.877h8.87a2.88 2.88 0 0 1 2.876 2.877v8.117a2.88 2.88 0 0 1-2.876 2.877h-8.87a2.88 2.88 0 0 1-2.876-2.877z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-gradient_svg__c)",
    d: "M19.945 22.556a4.14 4.14 0 0 0 4.134-4.135 4.14 4.14 0 0 0-4.134-4.135 4.14 4.14 0 0 0-4.133 4.135 4.14 4.14 0 0 0 4.133 4.135m0-6.7a2.57 2.57 0 0 1 2.566 2.566 2.57 2.57 0 0 1-2.566 2.567 2.57 2.57 0 0 1-2.566-2.567 2.57 2.57 0 0 1 2.566-2.567"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-gradient_svg__d)",
    d: "M24.462 14.952a1.115 1.115 0 0 0 0-2.228 1.115 1.115 0 0 0 0 2.228"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram-gradient_svg__a",
    x1: 10.434,
    x2: 35.77,
    y1: 0,
    y2: 37.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram-gradient_svg__b",
    x1: 15.506,
    x2: 26.648,
    y1: 9.92,
    y2: 27.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram-gradient_svg__c",
    x1: 17.878,
    x2: 23.392,
    y1: 14.286,
    y2: 22.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram-gradient_svg__d",
    x1: 23.905,
    x2: 25.391,
    y1: 12.724,
    y2: 14.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6937F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#FFE5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgInstagramGradient;